'use strict';
(function(angular) {
  angular
    .module('activationApp.controllers')
    .controller('ActivationCtrl', [
      '$scope',
      '$rootScope',
      '$q',
      '$state',
      '$window',
      '$location',
      '$sce',
      'dataService',
      'locationService',
      'packagesService',
      'fetchService',
      'billingService',
      'modalService',
      'basepackid',
      'ultimatePackId',
      'ultimatePackIntroActivated',
      'ultimatePackIntroOrdered',
      'skinnyPackIds',
      'toolboxbaseurl',
      'recaptchaKey',
      'vcRecaptchaService',
      function(
        $scope,
        $rootScope,
        $q,
        $state,
        $window,
        $location,
        $sce,
        dataService,
        locationService,
        packagesService,
        fetchService,
        billingService,
        modalService,
        /** Base pack UUID
         * @type {String} **/
        basepackid,
        /** Ultimate pack UUID
         * @type {String} **/
        ultimatePackId,
        /** Ultimate pack Trial (Activated) UUID
         * @type {String} **/
        ultimatePackIntroActivated,
        /** Ultimate pack Trial (Ordered) UUID
         * @type {String} **/
        ultimatePackIntroOrdered,
        /** List of skinny pack
         * @type {Array<Object>} **/
        skinnyPackIds,
        /** Toolbox URL prefix.
         * @type {String} **/
        toolboxbaseurl,
        recaptchaKey,
        vcRecaptchaService,
      ) {
        /** Flags whether or not this is a reactivation
         * @type {Boolean} **/
        $rootScope.reactivation = false;

        const preSelectedPacks = new Set([
          basepackid,  // Base Pack.
          ($scope.reactivation  // Pre-select either promo ultimate or regular ultimate depending on reactivation.
            ? ultimatePackId
            : ultimatePackIntroOrdered),
        ]),
          hiddenPacks = new Set([
            ultimatePackIntroActivated,
            ($scope.reactivation  // When reactivating, remove promo pack as an option, replaced with regular ultimate.
              ? ultimatePackIntroOrdered
              : ultimatePackId),
          ]),
          promoPacks = new Set([
            ultimatePackIntroOrdered,
            ultimatePackIntroActivated,
          ]);
        const skinnyPackMetadata = {
          "Kids Pack": {
            name: 'Kids',
            headerBg: '#F00A6A',
            headerColor: '#FFFFFF',
          },
          "Knowledge": {
            headerBg: "#FFCD00",
            headerColor: "#FFFFFF",
          },
          "Vibe": {
            headerBg: "#2DD98F",
            headerColor: "#FFFFFF",
          },
          "Variety": {
            headerBg: "#6849FF",
            headerColor: "#FFFFFF",
          },
        },
          packDetailsUrl = {
            "Kids Pack": `/packages/premium-channels/kids`,
            "Knowledge": `/packages/premium-channels/knowledge`,
            "Vibe": `/packages/premium-channels/vibe`,
            "Variety": `/packages/premium-channels/variety`,
            "Movie Box": `/movie/box`,
            "beIN SPORTS": `/packages/special-interest/bein-sports`,
            "Italian": `/packages/special-interest/italian`,
            "Horse and Country": `/packages/special-interest/horse-country`,
          };

        // Number of skinny packs selected before prompting for Ultimate upgrade.
        /** @type {Number} **/
        const SKINNY_UPGRADE_THRESHOLD = 3;

        var allowNext = false;

        $scope.details = dataService.getData().details;
        /*
         *$scope.details.email = 'k@k.co';
         *$scope.details.email_confirmation = 'k@k.co';
         *$scope.details.password = 'Password1@';
         *$scope.details.password_confirmation = 'Password1@';
         *$scope.details.title ="Mr";
         *$scope.details.first_name ='Coca';
         *$scope.details.last_name= 'Cola';
         *$scope.details.street = 'streetooo';
         *$scope.details.suburb='la burb';
         *$scope.details.state = 'New South Wales';
         *$scope.details.postcode = '0000';
         *$scope.details.mobile_number = '0000000000';
         *$scope.details.place_of_purchase = 'Domayne';
         *$scope.details.isp = 'iiNet';
         *$scope.details.tsandcs_checked = true;
         */

        $scope.titles = dataService.getTitles();
        $scope.states = dataService.getStates();
        $scope.ISPs = dataService.getISPs();
        $scope.retailers = dataService.getRetailers();
        $scope.skinnyPackIds = skinnyPackIds;

        var validEmailAddress = undefined;
        /** Unset valid email address if current entered email fields are invalid.
         **/
        function validateEmail() {
          if (validEmailAddress !== $scope.details.email) {
            validEmailAddress = undefined;
          }

          if (validEmailAddress !== $scope.details.email_confirmation) {
            validEmailAddress = undefined;
          }
        }

        /** Validate and return value of validated email
         * @returns {String} Valid email.
         **/
        function getConfirmedEmail() {
          validateEmail();
          if ($scope.details.email === $scope.details.email_confirmation) {
            return $scope.details.email;
          }
          return undefined;
        }

        $scope.emailChanged = function() {
          $scope.existingUser = undefined;
        };

        /* Captcha support BEGIN */
        $scope.recaptchaKey = recaptchaKey;
        var captchaWidgetId = undefined;
        $scope.onCaptchaCreate = function(widgetId) {
          captchaWidgetId = widgetId;
        };

        /** Callback when captcha challenge is successful
         * @param {string} token Captcha token from successful challenge.
         **/
        $scope.onCaptchaSuccess = function(token) {
          var proposedEmail = $scope.details.email;
          return fetchService.userExists(
            proposedEmail,
            token)
            .then(function(usernameExists) {
              if (usernameExists === false) {
                validEmailAddress = proposedEmail;
              }
              $scope.existingUser = usernameExists;
            })['finally'](function() {
              vcRecaptchaService.reload(captchaWidgetId);
            });
        };

        $scope.showChangeUserCaptcha = function() {
          if ($scope.existingUser) {
            return false;
          }

          if (validEmailAddress && getConfirmedEmail() === validEmailAddress) {
            // Already validated
            return false;
          }
          return getConfirmedEmail() !== undefined;
        };
        /* Captcha support END */

        function getCookie(cname) {
          var name = cname + '=';
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return '';
        }

        /** Attempt to load reactivation details from cookie
         **/
        function processReactivationRequest() {
          var cookie = getCookie('reactivate');
          if (cookie) {
            try {
              var inomialUser = JSON.parse(cookie);
              $rootScope.user = inomialUser;
              $scope.details = {
                title: inomialUser.AccountHolder.Salutation,
                email: inomialUser.AccountHolder.EmailAddress,
                email_confirmation: inomialUser.AccountHolder.EmailAddress,
                first_name: inomialUser.AccountHolder.GivenName,
                last_name: inomialUser.AccountHolder.FamilyName,
                postcode: inomialUser.PostalAddress.PostCode,
                state: _.where($scope.states, {
                  label: inomialUser.PostalAddress.State
                })[0],
                mobile_number: inomialUser.AccountHolder.MobileNumber,
                phone_number: inomialUser.AccountHolder.HomeNumber,
                payment: {
                  ezidebit_reference: inomialUser.PaymentDetails.CreditCardDetails.EziDebitRef
                }
              };
              $rootScope.reactivation = $scope.reactivation = true;
              billingService.getAnniversaryDate()
                .then(function(anniversaryDate) {
                  $scope.anniversaryDate = anniversaryDate;
                });
            } catch (err) {
            }
          }
          document.cookie = 'reactivate=;path=/';
        }

        processReactivationRequest();

        /** Pre-select marketing communications **/
        $scope.details.marketing_material1 = true;
        $scope.details.marketing_material2 = true;

        /**
         * Bounce back to welcome screen if activation user has not been defined.
         * This should be set when the user clicks 'Get Started' from the welcome screen or is processing a reactivation.
         *
         */
        if (!angular.isDefined($rootScope.user)) {
          $location.path('/welcome');
        }

        $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
          if (locationService.goingForward(fromState, toState)) {
            if (!allowNext) {
              event.preventDefault();
            }
          }
        });

        /** Handler for navigating to next step.
         **/
        $scope.goNext = function() {
          allowNext = true;
          locationService.goNext();
          allowNext = false;
        };

        /** Handler for navigating to previous step.
         **/
        $scope.goBack = function() {
          locationService.goBack();
        };

        /**
         * Navigate broweser to retail login page.
         * @param {String} [emailAddress] Email address to pass to loging page for prefill.
         *
         * @returns {undefined}
         */
        $scope.navigateToLogin = function(emailAddress) {
          var url = $scope.toolboxbaseurl + '#/logon';
          if (angular.isDefined(emailAddress)) {
            url = url + '/' + emailAddress;
          }
          $window.location = url;
        };

        /** UI helper method to determine if navigation can proceed forward
         **/
        $scope.isContinueButtonDisabled = function() {
          if (this.form) {
            if (!$scope.details.tsandcs_checked) {
              return true;
            }

            if (this.form.$invalid) {
              return true;
            }

            if ($location.path() == '/activate/step3') {
              return !$scope.step3Model.cardOk || this.form.$pending;
            } else if ($location.path() == '/activate/step1') {
              if (!$scope.reactivation) {
                return validEmailAddress === undefined;
              }
            }
          }
          return false;
        };

        /** UI helper method to determine if backward navigation is permitted.
         **/
        $scope.isBackButtonHidden = function() {
          if (($location.path() == '/activate/step1') && ($scope.reactivation)) {
            return true;
          }
          return false;
        };

        // step 1
        $scope.existingUser = undefined;

        $scope.checkISP = function() {
          if ($scope.details.isp.can_subscribe && dataService.showPartners()) {
            $('.partner-isp.modal').modal('show');
          }
        };

        // step 2
        /** Opt out of the pre-selected packages and customise subscription
         **/
        $scope.customisePackageSelection = () => {
          $scope.preferredPackageSelection = false;
        };

        /** Handler for toggling package selection
         * @param {SubscriptionPack} pack Relevent pack definition.
         **/
        $scope.addRemoveOptionalPack = function(pack) {
          // Ensure we are in "customisation mode"
          $scope.customisePackageSelection();
          //needed because ng-disable still allows click handler bizarrely.
          if (pack.included()) {
            return $q.reject();
          }

          //raise popup if should upgrade
          /** @type {Promise<Boolean>} **/
          let proceed = $q.when(pack);
          if (
            pack.isSkinnyPack()
            && !pack.selected === true
            && $scope.includedSkinnyPacks.length === SKINNY_UPGRADE_THRESHOLD
          ) {
            proceed = modalService.showConfirmAction(
              {
                title: "Ultimate Pack Upgrade Available",
                line1: "It's cheaper for you to upgrade to the Ultimate Pack rather than add a fourth pack.",
                line2: "The Ultimate Pack includes all four packs.",
                okText: 'Upgrade Now',
              },
            ).then(
                result => {
                  // Accept upgrade offer
                  if (result === 'accept') {
                    return $scope.ultimatePack;
                  }
                  // This should never happen as dismissing dialog should reject promise.
                  return pack;
                },
              );
          }

          return proceed.then(
              packToSubscribe => {
                packToSubscribe.selected = !packToSubscribe.selected;

                //logic for ultimate and skinny packs
                if (packToSubscribe.isUltimate()) {
                  if (!packToSubscribe.selected) {
                    //** ultimate pack removed
                    packToSubscribe.addUpgradeText = "Add";
                    $scope.includedSkinnyPacks = [];
                  }
                  // De-select all skinny packs
                  $scope.skinnyPacks.forEach(
                    p => p.selected = false,
                  );
                } else if (packToSubscribe.isSkinnyPack()) {
                  var newIncludedSkinnyPacks = [];
                  $scope.skinnyPacks.forEach(skinnyPack => {
                    if (skinnyPack.selected) {
                      newIncludedSkinnyPacks.push(skinnyPack);
                    }
                  });
                  // Update listed included skinny packs.
                  $scope.includedSkinnyPacks = newIncludedSkinnyPacks;

                  if ($scope.ultimatePack) {
                    if ($scope.includedSkinnyPacks.length > 0) {
                      $scope.ultimatePack.addUpgradeText = "Upgrade";
                    } else {
                      $scope.ultimatePack.addUpgradeText = "Add";
                    }
                  }
                }

                return updatePriceTotals();
              });
        };

        /** Recalculate total price of selected packs
         **/
        function updatePriceTotals() {
          $scope.totalPricePerMonth = $scope.packs
            .filter(p => p && p.selected)
            .map(p => p.PricePerMonth)
            .reduce((total, price) => total + price, 0);

          $scope.activationPrice = $scope.packs
            .filter(p => p && p.selected)
            .map(p => p.SetupFee)
            .reduce((total, price) => total + price, 0);

          $scope.totalPrice = $scope.totalPricePerMonth + $scope.activationPrice;
        }

        $scope.showPackInPriceList = function(pack) {
          var showPack = false;
          if(pack.selected) {
            if (pack.isBasePack()) {
              return false;
            } else {
              showPack = true;
            }
          }
          return showPack;
        };

        $scope.getBasePack = function() {
          return $scope.packs.find(p => p.isBasePack());
        };

        /** @type {Set<String>} **/
        const skinnyPackIdNumbers = new Set(
          ($scope.skinnyPackIds || []).map(p => p.id),
        );

        const ultimatePackIds = new Set([
          ultimatePackId,
          ultimatePackIntroOrdered,
          ultimatePackIntroActivated,
        ]);

        class TemporaryOfferDetails {
          /**
           * @param {String} trialPeriod String displaying trial period.
           * @param {Number} trialPrice Price during period.
           * @param {Number} postTrialPrice Price after trial lapses
           **/
          constructor(
            trialPeriod,
            trialPrice=0,
            postTrialPrice=0,
          ) {
            /** @type {String} **/
            this.trialFreePeriod = trialPeriod;

            /** @type {Number} **/
            this.trialPrice = trialPrice;

            /** @type {Number} **/
            this.postTrialPrice= postTrialPrice;
          }
        }

        class SubscriptionPack {
          /**
           * @param {Object} packDetails
           * @param {Array<String>} channelImageUrls
           * @param {TemporaryOfferDetails} trialDetails
           * @param {String} detailsUrl Url to access further details about given pack.
           **/
          constructor(
            packDetails,
            channelImageUrls,
            trialDetails=undefined,
            detailsUrl=undefined,
          ) {
            /*
            Example of packDetails dictionary.
            {
                "FetchPackageId": "d9fa2fc6-df0c-11e3-85f4-3c4a92ea0dda",
                "Name": "Starter Pack",
                "PricePerMonth": 0,
                "SetupFee": 1
            }
            */
            /** Original fetch package id
             * @deprecated
             * @type {String}
             **/
            this.FetchPackageId = packDetails.FetchPackageId;
            /** Package identifier UUID.
             * @type {String}
             **/
            this.fetchPackageId = packDetails.FetchPackageId;
            /** @type {String} **/
            this.name = packDetails.Name;
            this.displayName = packDetails.Name;
            /* TODO: rename the following fields. */
            /** @type {Number} **/
            this.PricePerMonth = packDetails.PricePerMonth;
            /** Background display colour for header.
             * @type {String} **/
            this.priceSubText = 'per month';

            /** @type {Number} **/
            this.SetupFee = packDetails.SetupFee;

            /** @type {Array<String>} **/
            this.channels = channelImageUrls;

            /** Background display colour for header.
             * @type {String} **/
            this.headerBg = undefined;
            /** Foreground header text display colour.
             * @type {String} **/
            this.headerColor = undefined;
            /** Add action button text.
             * @type {String} **/
            this.addUpgradeText = 'Add';

            /** @type {Boolean} **/
            this.selected = false;
            /** When false, this pack is not optional
             * @type {Boolean} **/
            this.optional = true;
            /** Additional message to display on pack, this should be $sce escaped.
             * @type {String} **/
            this.message = undefined;
            /** @type {TemporaryOfferDetails} **/
            this.trialDetails = trialDetails;

            /** @type {String} **/
            this.detailsUrl = detailsUrl;
          }

          /** When true, package is ultimate.
           * @returns {Boolean}
           **/
          isUltimate() {
            return ultimatePackIds.has(this.fetchPackageId);
          }

          /** When true, pack is a skinny pack.
           * @returns {Boolean}
           **/
          isSkinnyPack() {
            return skinnyPackIdNumbers.has(this.fetchPackageId);
          }

          /** Returns whether or not pack is included.
           * @returns {Boolean} When included as part of another pack selection
           **/
          included() {
            return this.isSkinnyPack() && $scope.ultimatePack.selected;
          }

          /** When true, package is ultimate.
           * @returns {Boolean}
           **/
          isBasePack() {
            return this.fetchPackageId === basepackid;
          }

          /** When true, package is Movie box.
           * @returns {Boolean}
           **/
          isMovieBox() {
            return this.name === 'Movie Box';
          }

          /** Whether pack is a promotional pack
           * @returns {Boolean} **/
          isPromoPack() {
            return promoPacks.has(this.fetchPackageId);
          }

          /** Determine whether included channels should be displayed
           **/
          displayChannels() {
            if (this.isUltimate()) {
              return false;
            }
            if (this.isMovieBox()) {
              return false;
            }
            return true;
          }

          getTickIconClass() {
            if (this.isSkinnyPack()) {
              const packName = this.name.toLowerCase().replace('pack', '').trim();
              return `svg-tick-${ packName }`;
            }
            return `tick-blue`;
          }
        }

        /** Load and build subscribable package list
         * @returns {Promise<Array<SubscriptionPack>>} Subscription packs.
         **/
        function getPackagesList() {
          $scope.basePack = undefined;
          $scope.ultimatePack = undefined;
          $scope.fullUltimatePack = undefined;
          $scope.skinnyPacks = [];
          $scope.movieBox = undefined;
          $scope.otherPacks = [];

          $scope.includedSkinnyPacks = [];

          return $q.all([
            packagesService.getAvailablePackages(),
            packagesService.getPackageDetails(),
          ])
            .then(results => {
              const availablePacks = results[0],
                packageDetails = results[1];

              availablePacks.forEach(p => {
                let channels = [];
                const packDetails = packageDetails[p.FetchPackageId];
                if (packDetails) {
                  channels = packDetails.channels;
                }

                /** @type {TemporaryOfferDetails} **/
                let temporaryDetails = undefined;

                if (promoPacks.has(p.FetchPackageId)) {
                  temporaryDetails = new TemporaryOfferDetails(
                    'for 1 Month and then',
                    0,
                    20,
                  );
                }
                function getChannelImageUrl (channelId) {
                  return `/img/premium_channel_logos/${ channelId }.png`;
                }

                const pack = new SubscriptionPack(
                  p,
                  channels.map(getChannelImageUrl),
                  temporaryDetails,
                  packDetailsUrl[p.Name],
                );

                if (preSelectedPacks.has(pack.fetchPackageId)) {
                  pack.selected = true;
                }

                if (p.FetchPackageId === basepackid) {
                  $scope.basePack = pack;
                  pack.optional = false;
                  return undefined;
                }
                //TODO: remove this, duplicated rubbish code.
                if (pack.isUltimate()) {
                  if (pack.fetchPackageId === ultimatePackId) {
                    $scope.fullUltimatePack = pack;
                  }

                  if (!hiddenPacks.has(pack.fetchPackageId)) {
                    $scope.ultimatePack = pack;
                  }

                  pack.displayName = "Ultimate Pack";
                  pack.headerBg = "#019BE5";
                  pack.headerColor = "#FFFFFF";
                  pack.detailsUrl = `/packages/premium-channels/ultimate`;

                  // Override included channes with the onese specified in the "real" Ultimate pack.
                  pack.channels = packageDetails[ultimatePackId].channels.map(getChannelImageUrl);

                  //** pack disclaimer text template **/
                  if (pack.isPromoPack()) {
                    pack.priceSubText = 'for the first month.';
                    pack.message = $sce.trustAsHtml('$20 per month after end of trial. No contract, pay monthly in advance.');
                  }
                  return undefined;
                }

                if (pack.isMovieBox()) {
                  $scope.movieBox = pack;
                  return undefined;
                }

                if ($scope.skinnyPackIds) {
                  /** @type {Boolean} **/
                  const packMetadata = skinnyPackMetadata[pack.name];
                  if (packMetadata !== undefined) {
                    pack.displayName = packMetadata.name || pack.name;
                    pack.headerBg = packMetadata.headerBg;
                    pack.headerColor = packMetadata.headerColor;
                    pack.message = packMetadata.message;
                  }

                  if (pack.isSkinnyPack()) {
                    $scope.skinnyPacks = [
                      ...$scope.skinnyPacks,
                      pack,
                    ];
                  } else {
                    $scope.otherPacks = [
                      ...$scope.otherPacks,
                      pack,
                    ];
                  }
                }

                return undefined;
              });

              return [
                $scope.ultimatePack,
                $scope.movieBox,
                ...$scope.skinnyPacks.sort(
                  (pa, _) => {
                    if (pa.name === 'Kids Pack') {
                      return 1;
                    }
                    return 0;
                  }),
                ...$scope.otherPacks,
                $scope.basePack,
              ];
            });
        }

        if (!$scope.packs) {
          $scope.packs = [];
          $q.when(getPackagesList())
            .then(packList => {
              $scope.packs = packList;
              $scope.details.packs = packList;
              updatePriceTotals();
            });
        }

        /** When true, only display preferred plan.
         * @type {Boolean} **/
        $scope.preferredPackageSelection = true;

        /** Visibility filter for package.
         * @param {SubscriptionPack} pack Pack to chest.
         * @returns {Boolean}
         **/
        $scope.packageDisplayFilter = function(
          pack,
        ) {
          if (pack.fetchPackageId === basepackid) {
            return false;
          }
          if ($scope.preferredPackageSelection) {
            return pack.selected;
          }
          if (hiddenPacks.has(pack.fetchPackageId)) {
            return false;
          }
          if (pack.optional) {
            return true;
          }
          return false;
        };

        // step 3
        $scope.step3Model = {
          allowedCreditCardTypes:['visa', 'mastercard'],
          cardOk:false
        };

        //step 4
        $scope.editCustomerDetails = function() {
          $state.transitionTo('activate.step1');
        };

        $scope.editPaymentMethod = function() {
          $state.transitionTo('activate.step3');
        };

        $scope.editPackages = function() {
          $state.transitionTo('activate.step2');
        };

        /** Return selected packs
         * @returns {Array<SubscriptionPack>} List of subscribed packs.
         **/
        $scope.selectedPacks = function() {
          return $scope.packs.filter(p => p.selected);
        };

        //step 5
        $scope.getActivationCode = function() {
          return $rootScope.user.SetTopBoxes.SetTopBox[0].ActivationCode;
        };

        $scope.getReceiptNumber = function() {
          return $rootScope.user.ReceiptNo;
        };

        $scope.toolboxbaseurl = toolboxbaseurl;

        var receiptDate = new Date();
        $scope.getReceiptDate = function() {
          return receiptDate;
        };
      }
    ]);
})(angular);
